import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"inherit\" xmlns=\"http://www.w3.org/2000/svg\" id=\"plus\">\n<path d=\"M15.8334 10.8337H10.8334V15.8337H9.16675V10.8337H4.16675V9.16699H9.16675V4.16699H10.8334V9.16699H15.8334V10.8337Z\" fill=\"inherit\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol